import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

export function onEnterMarvelRivalsGame(payload: unknown) {
  return refs.trackEvent(ANALYTIC_EVENTS.MR_START, payload);
}

export function onExitMarvelRivalsGame(payload: unknown) {
  return refs.trackEvent(ANALYTIC_EVENTS.MR_END, payload);
}
